import { getApi } from "./api_instance";

export const getHistoryDetails = async (
  { currentPage, pagelimit },
  dispatch
) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/notification/getNotificationsWithPagination?pageNumber=${currentPage}&pageSize=${pagelimit}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
